module.exports = __webpack_public_path__ + "fonts/Raleway-SemiBold.8a192102.ttf";